import { DonorLeaderboardState } from "./campaignLeaderDonors.types";

export const initialState: DonorLeaderboardState = {
  data: [],
  loading: false,
  error: null,
};
